'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = CallToAction;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLASS_NAME = 'call-to-action';

function CallToAction(_ref) {
	var icon = _ref.icon,
	    iconAlt = _ref.iconAlt,
	    image = _ref.image,
	    imageAlt = _ref.imageAlt,
	    title = _ref.title,
	    subtext = _ref.subtext,
	    buttonAltSubtext = _ref.buttonAltSubtext,
	    link = _ref.link;


	return _react2.default.createElement(
		'article',
		{ className: CLASS_NAME },
		_react2.default.createElement(
			'div',
			{ className: 'article-image' },
			_react2.default.createElement(
				'a',
				{ href: link.href },
				_react2.default.createElement('img', { src: image, alt: imageAlt })
			)
		),
		_react2.default.createElement(
			'div',
			{ className: 'article-content vertical-aligning' },
			_react2.default.createElement(
				'h2',
				null,
				_react2.default.createElement('img', { src: icon, alt: iconAlt }),
				title
			),
			_react2.default.createElement(
				'p',
				null,
				subtext
			),
			_react2.default.createElement(
				'a',
				{ className: 'button-link', href: link.href },
				_react2.default.createElement(
					'span',
					{ className: 'desktop-only' },
					link.label
				),
				_react2.default.createElement(
					'span',
					{ className: 'mobile-only' },
					link.buttonAltSubtext
				)
			)
		)
	);
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/CallToAction/CallToAction.jsx
// module id = 1067
// module chunks = 0